import React from "react";
import { Container, Row, Col } from 'react-bootstrap';
import Image from 'react-bootstrap/Image';

import { ServDevelopTop } from "../assets/ServDevelopData";
import { ServDevelopTopImg } from "../assets/ServDevelopData";
import { ServDevelopProduce } from "../assets/ServDevelopData";
import { ServDevelopProcFlow } from "../assets/ServDevelopData";
import { ServDevelopSensorEquip } from "../assets/ServDevelopData";
import { ServDevelopProdArea } from "../assets/ServDevelopData";
// import { ServDevelopProdPlant } from "../assets/ServDevelopData";
import { GoTopBtn } from '../components/GoTopBtn';
import './Services.css';

function ServiceDevelop() {
  // console.log("get into function ServiceDevelop()");
  return (
    <div className='services-page'>
      <header className='mt-1'>
        <Container className='d-flex align-items-center justify-content-center'>
          <h1 className='servdevelop'>Service / Development</h1>
        </Container>
      </header>
      <section id='servdeveloptop' className='servdevelop-block bg-primary-subtle'>
        <h2 className='title-holder fs-1 text-primary'>Development</h2>
        <Container fluid>
          <Row className='d-flex justify-content-center'>
            {ServDevelopTop.map(top => {
              return (
                <Col lg={12} key={top.id}>
                  <h2 className='m-4 text-center text-success'>{top.subtitle}</h2>
                  <p className='m-2 fw-bold fs-4' style={{ whiteSpace: 'pre-wrap' }}>{top.text}</p>
                  {/* <p className='m-2 fw-bold fs-4'>{top.text}</p> */}
                </Col>
              )
            })}
          </Row>
          <Row className='d-flex justify-content-around'>
            {ServDevelopTopImg.map(topimg => {
              return (
                // <Col lg={4} key={topimg.id}>
                <Col lg={4} key={topimg.id} className='d-lg-flex'>
                  <img src={topimg.image} className='img-fluid' alt={topimg.alt} />
                  {/* <Image src={topimg.image} alt={topimg.alt} /> */}
                </Col>
              );
            })}
          </Row>
          {/* <Row className='image'> <Image src={topimg.image} alt={topimg.alt} /> </Row> */}
          <br />
        </Container>
      </section>

      <section id='servdevelopproduce' className='servdevelop-block bg-info-subtle'>
        <Container fluid className='my-2'> {
          <Row className='d-flex'>
            {ServDevelopProduce.map(produce => {
              if (produce.image) {
                return (
                  <Row>
                    <h2 className='m-4 text-center text-primary bg-primary-subtle'>{produce.title}</h2>
                    {/* <h3 className='m-4 text-center text-primary'>{produce.subtitle}</h3> */}
                    <Col lg={6} key={produce.id}>
                      {/* <p className='m-2 fw-bold fs-4' style={{ whiteSpace: 'pre' }}>{produce.text}</p> */}
                      <img style={{ height: '50vh' }} src={produce.image} className='img-fluid' alt={produce.alt} />
                    </Col>
                    <Col lg={6} key={produce.id}>
                      <h2 className='m-4 text-center text-primary'>{produce.subtitle}</h2>
                      <p className='m-2 fw-bold fs-4' style={{ whiteSpace: 'pre-wrap' }}>{produce.text}</p>
                    </Col>
                  </Row>
                )
              }
              else {
                return (
                  <Row>
                    <h2 className='m-4 text-center text-primary bg-primary-subtle'>{produce.title}</h2>
                    <Col lg={2}></Col>
                    <Col lg={8} key={produce.id}>
                      <h3 className='m-4 text-center text-primary bg-success-subtle'>{produce.subtitle}</h3>
                      <p className='m-2 fw-bold fs-4' style={{ whiteSpace: 'pre-wrap' }}>{produce.text}</p>
                    </Col>
                    <Col lg={2}></Col>
                    </Row>
                )
              }
            })}
          </Row>
        } </Container>
      </section>

      <section id='servdevelopprocflow' className='servdevelop-block bg-primary-subtle'>
        <Container fluid className='my-2'>
          {/* <Container className='my-1'> */}
          {ServDevelopProcFlow.map(flow => {
            if (flow.image) {
              return (
                <Row key={flow.id} >
                  <h2 className='text-center text-primary bg-warning'>{flow.title}</h2>
                  <Col lg={8} className="d-flex justify-content-center">
                    <img style={{ width: '55vw' }} src={flow.image} alt={flow.alt} className='img-fluid' />
                    {/* <img style={{ height: '55vh' }} src={flow.image} alt={flow.alt} className='img-fluid' /> */}
                  </Col>
                  <Col lg={4}>
                    <h2 className='text-center text-primary bg-warning-subtle'>{flow.subtitle}</h2>
                    <p className='m-2 fw-bold fs-4' style={{ whiteSpace: 'pre-wrap' }}>{flow.text}</p>
                  </Col>
                </Row>
              )
            }
            else {
              return (
                <Row key={flow.id}>
                  <h2 className='m-4 text-center text-success'>{flow.subtitle}</h2>
                  <p className='m-2 fw-bold fs-4' style={{ whiteSpace: 'pre-wrap' }}>{flow.text}</p>
                </Row>
              )
            }
          })}
        </Container>
      </section>
      {/* 
      <section id='servdevelopprocflow' className='servdevelop-block bg-primary-subtle'>
        <Container className='my-1'> {
          <Row className='d-flex'> {
            ServDevelopProcFlow.map(flow => {
              if (flow.image) {
                return (
                  <Container>
                    <Row key={flow.id}>
                      <h2 className='m-4 text-center text-success'>{flow.title}</h2>
                      <img style={{ height: '60vh' }} src={flow.image} className='img-fluid' alt={flow.alt} />
                      <img style={{ width: '100vw' }} src={flow.image} className='img-fluid' alt={flow.alt} />
                    </Row>
                    <Row key={flow.id}>
                      <h2 className='m-4 text-center text-success'>{flow.subtitle}</h2>
                      <p className='m-2 fw-bold fs-4' style={{ whiteSpace: 'pre-wrap' }}>{flow.text}</p>
                    </Row>
                  </Container>
                )
              }
              else {
                return (
                  <Row key={flow.id}>
                    <h2 className='m-4 text-center text-success'>{flow.title}</h2>
                    <p className='m-2 fw-bold fs-4' style={{ whiteSpace: 'pre-wrap' }}>{flow.text}</p>
                  </Row>
                )
              }
            })
          } </Row>
        } </Container>
      </section>
      */}

      <section id='servdevelopeprodquip' className='servdevelop-block bg-info-subtle'>
        <div className='title-holder text-center'>
          <h1 className='servprodequip'>Service / Production Equipment</h1>
          <h2 className='fw-bold'>Production Equipments</h2>
          {/* <div className='fs-2'>Production Equipments</div> */}
        </div>
        <Container fluid className='d-flex'>
          <Row>
            {ServDevelopSensorEquip.map(equip => {
              if (equip.id === 0) {
                return (
                  <Row key={equip.id}>
                    <Row className='text-center'>
                      <h2 className='fw-bold'>{equip.title}</h2>
                      <h3>{equip.describe}</h3>
                      <h4 style={{ whiteSpace: 'pre-wrap' }}>{equip.text}</h4>
                    </Row>
                  </Row>
                )
              }
              else {
                return (
                  <Col sm={4} key={equip.id}>
                    <Row className='image d-flex justify-content-around'>
                      {/* <Row className='image d-flex justify-content-center'> */}
                      <Image style={{ width: '30vw' }} src={equip.image} alt={equip.alt} />
                      {/* <img style={{ height: '40vh' }} src={equip.image} className='mt-5 mt-lg-0' alt="" /> */}
                    </Row>
                    <Row className='text-center'>
                      <p className='fs-3 fw-bold'>{equip.title}</p>
                      <p className='fs-4'>{equip.describe}</p>
                      <p className='fs-5 '>{equip.text}</p>
                    </Row>
                  </Col>
                )
              }
            })}
          </Row>
        </Container>
      </section>
      {/*
      <section id='servdevelopeprodquip' className='servdevelop-block bg-info-subtle'>
        <Container fluid> {
          ServDevelopSensorEquip.map(equip => {
            if (equip.image) {
              return (
                <Row>
                  <h2 className='text-center text-primary bg-primary-subtle'>{equip.title}</h2>
                  <Col lg={7} key={equip.id}>
                    <img style={{ height: '65vh' }} src={equip.image} className='img-fluid' alt={equip.alt} />
                  </Col>
                  <Col lg={5} key={equip.id}>
                    <h2 className='m-4 text-center text-primary'>{equip.subtitle}</h2>
                    <p className='m-2 fw-bold fs-4' style={{ whiteSpace: 'pre-wrap' }}>{equip.text}</p>
                  </Col>
                </Row>
              )
            }
            else {
              return (
                <Row key={equip.id}>
                  <h2 className='text-center text-primary bg-primary-subtle'>{equip.title}</h2>
                  <h2 className='text-center text-primary bg-primary-subtle'>{equip.subtitle}</h2>
                  <p className='m-2 fw-bold fs-4' style={{ whiteSpace: 'pre-wrap' }}>{equip.text}</p>
                </Row>
              )
            }
          })
        } </Container>
      </section>
      */}
      <section id='servdevelopprodplant' className='servdevelop-block bg-primary-subtle'>
        <Container fluid className='my-1'>
          {ServDevelopProdArea.map(plant => {
            return (
              <Container fluid>
                <Row key={plant.id} className='image d-flex justify-content-around'>
                  <h2 className='m-4 text-center text-success bg-warning'>{plant.title}</h2>
                  <img src={plant.image} className='img-fluid' alt={plant.alt} />
                  {/* <img style={{ width:'200vw', height:'65vh' }} src={plant.image} className='img-fluid' alt={plant.alt} /> */}
                </Row>
                <Row key={plant.id}>
                  <Col lg={2}></Col>
                  <Col lg={8}>
                    <h2 className='m-4 text-center text-success bg-warning-subtle'>{plant.subtitle}</h2>
                    <p className='m-2 fw-bold fs-4' style={{ whiteSpace: 'pre-wrap' }}>{plant.text}</p>
                  </Col>
                  <Col lg={2}></Col>
                </Row>
              </Container>
            )
          })}
        </Container>
      </section>
      <div> < GoTopBtn /> </div>
    </div >
  );
}

export default ServiceDevelop;